export default __webpack_public_path__ + "static/AlertSettingToggle-68b3829eab70973be12b83c744bb22bf.png";